import client from "lib/apolloClient/client";
import { cache } from "lib/apolloClient";

import fragments, {
  configurationFragments,
  projectGroupFragments,
} from "./Fragments";

export const getPermissionBasicDetailsFromCache = permissionId => {
  return client.readFragment({
    id: cache.identify({ __typename: "ACLPermission", uid: permissionId }),
    fragment: fragments.permissionBasicDetails,
    fragmentName: "permissionBasicDetailsItem",
  });
};

export const getFeatureFlagBasicDetailsFromCache = featureFlagId => {
  return client.readFragment({
    id: cache.identify({ __typename: "ACLFeatureFlag", uid: featureFlagId }),
    fragment: fragments.featureFlagBasicDetails,
    fragmentName: "featureFlagBasicDetailsItem",
  });
};

export const getPreferenceBasicDetailsFromCache = preferenceId => {
  return client.readFragment({
    id: cache.identify({ __typename: "ACLPreference", uid: preferenceId }),
    fragment: fragments.preferenceBasicDetails,
    fragmentName: "preferenceBasicDetailsItem",
  });
};

export const getConfigurationBasicDetailsFromCache = configurationId => {
  return client.readFragment({
    id: cache.identify({
      __typename: "ConfigurationV2",
      uidV2: configurationId,
    }),
    fragment: configurationFragments.basicDetails,
    fragmentName: "configurationV2Item",
  });
};

export const getProjectGroupBasicDetails = projectGroupId => {
  return client.readFragment({
    id: `ProjectGroupCategory:${projectGroupId}`,
    fragment: projectGroupFragments.basicDetails,
    fragmentName: "projectGroupBasicDetailsItem",
  });
};

export const getProjectGroupProgramDetails = projectGroupId => {
  return client.readFragment({
    id: `ProjectGroupCategory:${projectGroupId}`,
    fragment: projectGroupFragments.programDetails,
    fragmentName: "projectGroupProgramDetailsItem",
  });
};
